import './App.css';
import React, { useState, useRef, useEffect } from 'react';
import {
  Container,
  Typography,
  Stack,
  IconButton,
  Tooltip,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import EntryList from './components/EntryList';
import PdfExportButton from './components/PdfExportButton';
import JsonImportExport from './components/JsonImportExport';
import WelcomeModal from './components/WelcomeModal';

export type Entry = {
  id: string;
  qrText: string;
  markdownText: string;
  sanitizedHtml: string;
  isEditing: boolean;
  isNew: boolean;
  showPreviewWhileEditing: boolean;
};

const App: React.FC = () => {
  const [entries, setEntries] = useState<Entry[]>([]);
  const entryListRef = useRef<HTMLDivElement>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const hasSeenModal = localStorage.getItem('hasSeenWelcome');
    if (!hasSeenModal) {
      setShowModal(true);
    }
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    localStorage.setItem('hasSeenWelcome', 'true');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography className="title" variant="h4" align="center" gutterBottom>
        Label Generator
      </Typography>

      <Stack direction="row" spacing={2} justifyContent="flex-end" mb={2}>
        {entryListRef.current && (
          <PdfExportButton disabled={entries.length===0} targetElement={entryListRef.current} />
        )}
        <JsonImportExport entries={entries} setEntries={setEntries} />
        <Tooltip title="Show Welcome Info">
          <IconButton onClick={() => setShowModal(true)}>
            <HelpOutlineIcon />
          </IconButton>
        </Tooltip>
      </Stack>

      <div ref={entryListRef}>
        <EntryList entries={entries} setEntries={setEntries} />
      </div>

      <WelcomeModal isOpen={showModal} onClose={handleCloseModal} />
    </Container>
  );
};

export default App;
